import { Container } from '@screens/review-section3/styles';
import styled from 'styled-components';

export const FormI9Container = styled(Container)`
  max-width: 800px;
`;



// WEBPACK FOOTER //
// ./src/screens/review-section2/employee-information/styles.tsx